<template>
    <div class="wrapper">
        <div class="TopHeader">
            <div class="header-logo">
                <img src="../assets/logo.png" alt="">
                <p>销售锦囊</p>
            </div>
            <div class="searchbar">
                <div class="searchbar-query">
                    <el-input v-model="inputKeyWord" placeholder="请输入客户的关键词"></el-input>
                    <el-cascader 
                    placeholder="河南" 
                    v-model="regionValue" 
                    :options="regionList" 
                    clearable
                    @change="handleChange" 
                    :props="optionProps"
                     collapse-tags></el-cascader>
                    <el-button icon="el-icon-search" type="primary" :disabled="!inputKeyWord || !regionValue" @click="search"></el-button>
                </div>
                <!-- <div class="searchbar-hot">
                    <span>销售热搜词 ：<em>(30日)</em></span>
                    <el-dropdown @command="handleHot">
                        <span class="el-dropdown-link">
                            <span v-if="inputKeyWord == ''" >请选择</span>
                            <span v-else>{{inputKeyWord}}</span>
                            <i class="el-icon-arrow-down el-icon--right"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown" class="dropdown-scrollbar">
                            <el-scrollbar>
                                <el-dropdown-item v-for="(item) in hotKeyWord" :key="item.key" :command='item.label' >{{item.label}}</el-dropdown-item>
                            </el-scrollbar>
                        </el-dropdown-menu>
                        </el-dropdown>
                </div> -->
            </div>
        </div>
        <div class="container">
            <LeftMenu></LeftMenu>
            <div class="content">
                <!-- <router-view :keyWord="inputKeyWord" :regionValue="regionValue.map(e=>e[1])" ref="currentRouteView"></router-view> -->
                <router-view :keyWord="inputKeyWord" :regionValue="regionValue" ref="currentRouteView"></router-view>
            </div>
        </div>
    </div>
</template>
<script>
import LeftMenu from '../components/LeftMenu.vue'
import { getProvInfo } from '../utils/request.js'
export default {
    name: 'App',
    components: {
        LeftMenu
    },
    data() {
        return {
            inputKeyWord: '',
            regionValue: [12],//默认区域：河南
            // hotKeyWord: [{
            //         key:'1',
            //         value: '选项1',
            //         label: '装修'
            //     }, {
            //         key:'2',
            //         value: '选项2',
            //         label: '机械'
            //     }, {
            //         key:'2',
            //         value: '选项2',
            //         label: '机械'
            //     }, {
            //         key:'2',
            //         value: '选项2',
            //         label: '机械'
            //     }, {
            //         key:'2',
            //         value: '选项2',
            //         label: '机械'
            //     }, {
            //         key:'2',
            //         value: '选项2',
            //         label: '机械'
            //     }, {
            //         key:'2',
            //         value: '选项2',
            //         label: '机械'
            //     }, {
            //         key:'2',
            //         value: '选项2',
            //         label: '机械'
            //     }, {
            //         key:'2',
            //         value: '选项2',
            //         label: '机械2214234s'
            //     }],
            optionProps:{
				value: 'provId',
				label: 'provName',
                multiple: true
			},
            regionList: [{
                provId: 'all',
                provName: '全部地区',
                children: []
            }]
        }
    },
    created() {
        this.getProvInfoData();
    },
    methods: {
        handleChange(value) {
            console.log(value);
        },
        handleHot(command) {
            console.log(command);

            this.inputKeyWord = command //选择热词，赋值给搜索框。
        },
        search(){
                this.$refs.currentRouteView.search();
        },
        getProvInfoData() { //获取区域数据
            let params = {
                // 后端规定要传的参数： 你要传的值
            }
            getProvInfo(params).then(res => {
                if(res.status == 200) {
                    this.regionList[0].children = res.data.data
                    console.log(this.regionList[0].children,'获取区域数据')
                } else {
                    this.$message.error(res.msg);
                }
                
            })
        }
    }
}
</script>

<style lang="less" scoped>
@import "../assets/reset.less";

.TopHeader {
    height: 80px;
    background-color: #fff;
    display: flex;
    align-items: center;
    padding: 10px;
    border-bottom: 1px solid @Color1;

    .header-logo {
        display: flex;
        align-items: center;

        img {
            width: 160px;
            object-fit: cover;
        }

        p {
            margin: 0px;
            padding: 10px;
            font-size: 18px;
            margin-left: 10px;
            border-left: 1px solid @Color1;
            font-weight: bold;
        }
    }

    .searchbar {
        flex: 1;
        display: flex;
        align-items: center;
        max-width: 1200px;
        padding: 0px 80px;
        justify-content: center;
        .searchbar-query {
            display: flex;
            margin-right: 10px;

            .el-input {
                width: 200px;

                /deep/ .el-input__inner {
                    border-top-right-radius: 0px;
                    border-bottom-right-radius: 0px;
                    margin-right: -1px;
                }
            }

            .el-cascader {
                width: 260px;

                /deep/ .el-input__inner {
                    border-top-left-radius: 0px;
                    border-bottom-left-radius: 0px;
                    border-top-right-radius: 0px;
                    border-bottom-right-radius: 0px;
                }
            }

            .el-button {
                border-top-left-radius: 0px;
                border-bottom-left-radius: 0px;
            }
        }

        .searchbar-hot {
            color: @Color10;

            span {
                margin-right: 10px;

                em {
                    font-style: normal;
                    color: @Color9;
                }
            }

            .el-dropdown-link {
                color: @Color8;
            }
        }
    }
}

.container {
    display: flex;

    .content {
        flex: 1;
        max-width: 1200px;
    }
}

/deep/ .el-scrollbar {
    height: 230px;

    .el-scrollbar__wrap {
        overflow-x: hidden;
        max-height: 230px !important;
    }
}
</style>
